import { render } from "./TransformerHub.vue?vue&type=template&id=c6519dfa"
import script from "./TransformerHub.vue?vue&type=script&lang=js"
export * from "./TransformerHub.vue?vue&type=script&lang=js"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__